export enum ERole {
  ROLE_SITE_SUPER_ADMIN = 'ROLE_SITE_SUPER_ADMIN',
  ROLE_SITE_ADMIN = 'ROLE_SITE_ADMIN',
  ROLE_SITE_MANAGER = 'ROLE_SITE_MANAGER',
  ROLE_SITE_MAIN_CLEANER = 'ROLE_SITE_MAIN_CLEANER',
  ROLE_SITE_CLEANER = 'ROLE_SITE_CLEANER',
  ROLE_SITE_PROPERTY_OWNER = 'ROLE_SITE_PROPERTY_OWNER',
  ROLE_SITE_CUSTOM = 'ROLE_SITE_CUSTOM',
}
